import { render } from "./ChatImageAgreement.vue?vue&type=template&id=e4e7b942&scoped=true&ts=true"
import script from "./ChatImageAgreement.vue?vue&type=script&lang=ts"
export * from "./ChatImageAgreement.vue?vue&type=script&lang=ts"

import "./ChatImageAgreement.vue?vue&type=style&index=0&id=e4e7b942&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e7b942"]])

export default __exports__